<template>
  <div class="comp-mentor">
    <div class="img">
      <router-link :to="`${$subsitePrefix}/company/mentor/detail/` + data.Id" :target="target">
        <img @error="imgError" :src="data.Photo" :alt="data.Name" />
      </router-link>
    </div>
    <div class="name">
      <h3>
        <router-link :to="`${$subsitePrefix}/company/mentor/detail/` + data.Id" :target="target">{{ data.Name }}</router-link>
      </h3>
      <p>企业导师</p>
      <p>{{ data.ProfessionalTitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "mentor-card",
  props: {
    data: {
      type: Object
    },
    target: {
      type: String,
      default: "_self"
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-mentor {
  width: 376px;
  height: 144px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.08);
  border-radius: 8px;
  display: flex;
  box-sizing: border-box;
  margin-bottom: 24px;
  margin-left: 24px;
  .img {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    overflow: hidden;
  }
  .name {
    padding-left: 24px;
    h3 {
      font-size: 20px;
      padding: 10px 0 5px 0;
      font-weight: 500;
    }
    p {
      color: #999;
      line-height: 24px;
    }
  }
  padding: 24px;
  &:hover {
    background: linear-gradient(
      315deg,
      rgba(73, 113, 241, 1) 0%,
      rgba(69, 80, 238, 1) 100%
    );
    box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.5);
    h3,
    p {
      color: #fff;
      a {
        color: #fff;
      }
    }
  }
  &:nth-child(3n-2) {
    margin-left: 0;
  }
}
</style>
